import { useContext } from 'react'
import { UgeEditorContext } from '../contexts/editor'
import { editorGradient, editorIcon, ugeEditors } from '../types/editor'
import { Button, Container } from './style'

// todo: remove this when implementing filters
const EDITORS = ugeEditors.filter((editor) => editor !== 'filters')

const Navigation = () => {
    const { activeEditor, openEditor } = useContext(UgeEditorContext)

    return (
        <Container>
            {EDITORS.map((editor) => {
                const gradient = editorGradient(editor)
                const icon = editorIcon(editor)
                const isActive = editor === activeEditor
                const isDefault = editor === 'default'

                return (
                    <Button
                        gradient={isDefault && !isActive ? undefined : gradient}
                        icon={icon}
                        inverted={!isActive}
                        key={editor}
                        size="large"
                        onClick={() => openEditor(editor)}
                    />
                )
            })}
        </Container>
    )
}

export default Navigation
